module.exports = __webpack_public_path__ + "img/微信图片_20241203085622-p-500.5d1f6a75.jpg";